import { NoteSlides } from './'

class NoteApi {
  constructor(el) {
    this.dom = {el: el};
    this.dom.container = this.dom.el.querySelector('[data-js="note-slide-container"]');

    this.id = 'sib_id';
    // this.url = 'https://www.shiseidointeractive.com/ja/news_files/json/news.json';
    // this.url = 'https://note.com/sib_id/rss';
    // this.url = 'https://note.com/sib_id/rss';

    /*
     * note.comの情報を取得するAPIのパス
     *
     * 本番サーバ ※2024/07/11時点
     * https://www.shiseidointeractive.com/ja/
     * https://www.shiseidointeractive.com/sib_id/rss
     *
     * スカイテスト環境
     * https://dev.skybabies.jp/sib/
     * https://dev.skybabies.jp/ja/sib_id/rss/index.html
     *
     * ローカル
     * ../assets/rss.xml
     */
    this.url = '/sib_id/rss';
    //this.url = '/ja/sib_id/rss/index.html';
    //this.url = '../assets/rss.xml';

    this.html = '';

    this.init();
  }

  init() {
    const _this = this;

    onload = async () => {
      const parser = new DOMParser();
      const res = await fetch(this.url);
      const data = await res.text();
      const txt = await parser.parseFromString(data, 'text/xml');
      const item = txt.querySelectorAll('item');
      this.dom.container.innerHTML = this.createHtml(Array.from(item).slice(0, 3));

      const domNoteSlides = document.querySelector('[data-js="note-slide"]');
      if (domNoteSlides) new NoteSlides(domNoteSlides);
    }
  }

  createHtml(_data) {
    _data.forEach(data => {
      const link = data.querySelector('link').textContent;
      const title = data.querySelector('title').textContent;
      const thumbnail = data.getElementsByTagName('media:thumbnail')[0].innerHTML;
      const description = data.querySelector('description').textContent.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'');
      const creatorImage = data.getElementsByTagName('note:creatorImage')[0].innerHTML;
      const creatorName = data.getElementsByTagName('note:creatorName')[0].innerHTML;
      const pubDate = data.getElementsByTagName('pubDate')[0].innerHTML;
      const datatime = new Date(pubDate).toLocaleDateString('ja-JP', {year: 'numeric', month: '2-digit', day: '2-digit'}).split('/').join('-');
      const date = new Date(pubDate).toLocaleDateString('ja-JP',
        {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        });
      const time = new Date(pubDate).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});
      this.html += `
        <article class="swiper-slide hm-note-list">
          <a href="${link}" target="_blank" class="hm-note-list__inner">
            <div class="hm-note-list__group">
              <h3 class="hm-note-list__title">${title}</h3>
              <div class="hm-note-list__text">
                <p>${description}</p>
              </div>
            </div>
            <div class="hm-note-list-meta">
              <figure class="hm-note-list-meta__icon"><img src="${creatorImage}" width="28" height="28" alt="" loading="lazy"></figure>
              <div class="hm-note-list-meta-data">
                <span class="hm-note-list-meta-data__author">${creatorName}</span>
                <time datetime="${datatime}" class="hm-note-list-meta-data__time">${date} ${time}</time>
              </div>
            </div>
            <figure class="hm-note-list__image">
              <span class="c-clip"><img src="${thumbnail}" width="320" height="167" alt="" loading="lazy"></span>
            </figure>
          </a>
        </article>
      `;
    })
    return this.html;
  }
}

export default NoteApi
